/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from "react";
import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { withSkeletonLoading } from "@landtechnologies/components";
import { useZoningData } from "react-migration/domains/sites/hooks/useZoningData";
import { DesignationCategory } from "react-migration/domains/constraints/designation";
import logSiteCardEvent from "src/js/view/sites/logSiteCardEvent";

export const Zoning = withSkeletonLoading(({ hideSkeletonLoading }) => {
  const { t } = useTranslation();
  const [{ siteCardId }] = useGlobalState(Stores.site);

  const { loading, designations } = useZoningData(siteCardId as string);

  useEffect(() => {
    if (!loading) hideSkeletonLoading();
  }, [loading]);

  const openZoningLink = () => {
    logSiteCardEvent({ name: "Site Card Summary Tab - Zoning Link Clicked" });
  };

  return (
    <div className="atlas-p-4">
      <div className="atlas-pb-4 atlas-flex atlas-justify-between">
        <span className="atlas-font-medium atlas-text-xl atlas-text-neutral-800">
          {t("sites.card.summary.zoning.zoning_information")}
        </span>
      </div>

      {designations.map((designation) => (
        <div
          key={designation.id}
          className="atlas-border atlas-border-border-divider-subtle atlas-text-sm atlas-rounded-md atlas-drop-shadow-sm atlas-mb-4 last:atlas-mb-0"
        >
          <div className="atlas-font-medium atlas-text-neutral-900 atlas-p-1.5 atlas-pb-2 atlas-pt-2 atlas-border-b atlas-border-border-divider-subtle">
            <DesignationCategory
              categoryId={designation.sub_category?.id}
              title={`${designation.key_code} – ${designation.display_name}`}
            />
          </div>
          <div className="atlas-p-1.5 atlas-pb-2 atlas-pt-2 atlas-bg-background-light hover:atlas-bg-neutral-200 atlas-rounded-b-md">
            {designation.source?.documents?.[0]?.url && (
              <a
                data-testid="zoning-link"
                onClick={openZoningLink}
                type="button"
                href={designation.source.documents[0].url}
                target="_blank"
                className="atlas-text-left atlas-text-content-link atlas-flex atlas-items-center"
              >
                {t(
                  "view.components.deck.gl.constraints.constraints_details_panel.zoning_external_link"
                )}{" "}
                <i className="icon-lt-external-link-line atlas-ml-1" />
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
});
